/**
  Autogenerated file. Do not edit manually.
  @openapi https://search-bff.envdevel.com/v3/api-docs
*/

import type {
  AdminSearchGeoPointV2Response,
  AutogenSearchResponse,
  GenerateExposeRedirectUrlParams,
  GenerateExposeUrlParams,
  GetListingByIdParams,
  GetListingContactByIdParams,
  GetListingResponse,
  ListPropertiesForAutogenParams,
  ListPropertiesForMapParams,
  ListingContactResponse,
  ListingRedirectResponse,
  ListingUrlResponse,
  SearchFilterRequest,
  SearchGeoPointResponse,
  SearchListings1Params,
  SearchListingsParams,
  SearchListingsResponse
} from '../../models';

import { customInstance } from '../../custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Search the database for properties matching the search filter
 */
export const searchListings = (
    searchFilterRequest: SearchFilterRequest,
    params: SearchListingsParams,
 options?: SecondParameter<typeof customInstance<SearchListingsResponse>>,) => {
      return customInstance<SearchListingsResponse>(
      {url: `/api/v2/listing/search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchFilterRequest,
        params
    },
      options);
    }
  /**
 * @summary Search the database for geopoints matching the search filter in allowed countries
 */
export const listPropertiesForMap = (
    searchFilterRequest: SearchFilterRequest,
    params?: ListPropertiesForMapParams,
 options?: SecondParameter<typeof customInstance<SearchGeoPointResponse>>,) => {
      return customInstance<SearchGeoPointResponse>(
      {url: `/api/v2/listing/search/geopoints`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchFilterRequest,
        params
    },
      options);
    }
  /**
 * @summary Search the database for geopoints matching the search filter in allowed countries
 */
export const listPropertiesForAutogen = (
    searchFilterRequest: SearchFilterRequest,
    params: ListPropertiesForAutogenParams,
 options?: SecondParameter<typeof customInstance<AutogenSearchResponse>>,) => {
      return customInstance<AutogenSearchResponse>(
      {url: `/api/v2/listing/search/autogen/search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchFilterRequest,
        params
    },
      options);
    }
  /**
 * @summary Search the database for properties matching the search filter
 */
export const searchListings1 = (
    searchFilterRequest: SearchFilterRequest,
    params: SearchListings1Params,
 options?: SecondParameter<typeof customInstance<SearchListingsResponse>>,) => {
      return customInstance<SearchListingsResponse>(
      {url: `/api/v1/admin/listing/search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchFilterRequest,
        params
    },
      options);
    }
  /**
 * @summary Search the database for geopoints matching the search filter in allowed countries
 */
export const listPropertiesForMap1 = (
    searchFilterRequest: SearchFilterRequest,
 options?: SecondParameter<typeof customInstance<AdminSearchGeoPointV2Response>>,) => {
      return customInstance<AdminSearchGeoPointV2Response>(
      {url: `/api/v1/admin/listing/search/geopoints`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchFilterRequest
    },
      options);
    }
  /**
 * @summary Returns a listing based by listingId or displayId
 */
export const getListingById = (
    listingIdOrDisplayId: string,
    params: GetListingByIdParams,
 options?: SecondParameter<typeof customInstance<GetListingResponse>>,) => {
      return customInstance<GetListingResponse>(
      {url: `/api/v2/listing/${listingIdOrDisplayId}`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Takes in listingId or a displayId and an optional language parameter.
 * Returns a redirect url which can be used if the listing is deleted or moved permanently.
 * If language is not provided we fallback to the English url
 * @summary Returns the redirect url for the expose
 */
export const generateExposeRedirectUrl = (
    listingIdOrDisplayId: string,
    params?: GenerateExposeRedirectUrlParams,
 options?: SecondParameter<typeof customInstance<ListingRedirectResponse>>,) => {
      return customInstance<ListingRedirectResponse>(
      {url: `/api/v2/listing/${listingIdOrDisplayId}/url/redirect`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Takes in listingId or a displayId and a language. Will fill in all the optionally defined parameters
 * and return an url which points to the expose. If utag/display is provided here, then we CANNOT guarantee uniqueness.
 * That is up to the CRM provider to guarantee that displayId is unique
 * * Validates the agentId
 * * Keeps development and non development listings in mind
 * * If language and marketCountryCode combination is not valid, a different fitting language will be selected
 * * If privateOffice is specified, it will prefer that over the provided marketCountryCode
 * @summary Returns a correct url to the expose
 */
export const generateExposeUrl = (
    listingIdOrDisplayId: string,
    params?: GenerateExposeUrlParams,
 options?: SecondParameter<typeof customInstance<ListingUrlResponse>>,) => {
      return customInstance<ListingUrlResponse>(
      {url: `/api/v2/listing/${listingIdOrDisplayId}/url/expose`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Returns contact information for a listing by listingId or displayId
 */
export const getListingContactById = (
    listingIdOrDisplayId: string,
    params: GetListingContactByIdParams,
 options?: SecondParameter<typeof customInstance<ListingContactResponse>>,) => {
      return customInstance<ListingContactResponse>(
      {url: `/api/v2/listing/${listingIdOrDisplayId}/contact`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Returns a property/listing based by listingId
 */
export const adminListing = (
    listingIdOrDisplayId: string,
 options?: SecondParameter<typeof customInstance<string>>,) => {
      return customInstance<string>(
      {url: `/api/v1/admin/listing/${listingIdOrDisplayId}`, method: 'GET'
    },
      options);
    }
  export type SearchListingsResult = NonNullable<Awaited<ReturnType<typeof searchListings>>>
export type ListPropertiesForMapResult = NonNullable<Awaited<ReturnType<typeof listPropertiesForMap>>>
export type ListPropertiesForAutogenResult = NonNullable<Awaited<ReturnType<typeof listPropertiesForAutogen>>>
export type SearchListings1Result = NonNullable<Awaited<ReturnType<typeof searchListings1>>>
export type ListPropertiesForMap1Result = NonNullable<Awaited<ReturnType<typeof listPropertiesForMap1>>>
export type GetListingByIdResult = NonNullable<Awaited<ReturnType<typeof getListingById>>>
export type GenerateExposeRedirectUrlResult = NonNullable<Awaited<ReturnType<typeof generateExposeRedirectUrl>>>
export type GenerateExposeUrlResult = NonNullable<Awaited<ReturnType<typeof generateExposeUrl>>>
export type GetListingContactByIdResult = NonNullable<Awaited<ReturnType<typeof getListingContactById>>>
export type AdminListingResult = NonNullable<Awaited<ReturnType<typeof adminListing>>>
